import "./Home.css";

export const Home = () => {
    return <section className="Home"></section>
}